import { registerTab } from '../actions/tab';
import store from '../store';

const registerPdaTab = (tab) => {
  store.dispatch(registerTab(tab));
}

export default registerPdaTab;
